import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function CustomDropdown({ label, options, value, onChange }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative w-full mb-4">
      <label className="block text-[#EB6AB5] font-semibold mb-2 text-sm sm:text-base">
        {label}
      </label>

      {/* Dropdown Button */}
      <button
        onClick={() => setOpen(!open)}
        className={`w-full flex justify-between items-center px-4 py-3 rounded-xl border ${
          open
            ? "border-[#EB6AB5] bg-[#1c1c2e]/90"
            : "border-gray-700 bg-[#141428]/70"
        } text-white focus:outline-none transition-all duration-300 hover:border-[#EB6AB5]/60`}
      >
        <span className="truncate text-left text-sm sm:text-base">
          {value || "Select"}
        </span>
        {open ? (
          <ChevronUp className="text-[#EB6AB5]" size={20} />
        ) : (
          <ChevronDown className="text-[#EB6AB5]" size={20} />
        )}
      </button>

      {/* Dropdown Menu */}
      <AnimatePresence>
        {open && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute z-20 w-full mt-2 rounded-xl bg-[#1a1a2f]/95 border border-[#EB6AB5]/30 shadow-lg backdrop-blur-md overflow-hidden max-h-56 overflow-y-auto scrollbar-thin scrollbar-thumb-[#EB6AB5]/30"
          >
            {options.map((opt, idx) => (
              <li
                key={idx}
                onClick={() => {
                  onChange(opt);
                  setOpen(false);
                }}
                className={`px-4 py-3 cursor-pointer text-sm sm:text-base ${
                  opt === value
                    ? "bg-[#EB6AB5]/20 text-[#EB6AB5]"
                    : "text-gray-300 hover:bg-[#EB6AB5]/10 hover:text-white"
                } transition`}
              >
                {opt}
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
}
